import BlotFormatter from 'quill-blot-formatter';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './style.css';

Quill.register('modules/blotFormatter', BlotFormatter);

const Editor = forwardRef((props, ref) => {
  const [editorHtml, setEditorHtml] = useState('');
  const quillRef = useRef(null);

  useEffect(() => {
    const toolbar = document.querySelector('.ql-toolbar');
    if (toolbar) {
      toolbar.setAttribute('tabIndex', -1);
      toolbar.querySelectorAll('button').forEach(item => {
        item.setAttribute('tabIndex', -1);
      });
    }
  }, []);

  useEffect(() => {
    if (props.data) {
      setEditorHtml(props.data);
    }
  }, [props.data]);

  useImperativeHandle(ref, () => ({
    insertText: (text) => {
      if (quillRef.current) {
        const quill = quillRef.current.getEditor();
        const range = quill.getSelection(true);
        quill.insertText(range.index, text);
        quill.setSelection(range.index + text.length);
      }
    },
    getQuill: () => {
      if (quillRef.current) {
        return quillRef.current.getEditor();
      }
      return null;
    },
    getReactQuill: () => quillRef.current
  }));

  const handleChange = html => {
    setEditorHtml(html);
    props.value(html);
  };

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' }
      ],
      ['link', 'image', 'video'],
      ['clean']
    ],
    clipboard: {
      matchVisual: false
    },
    blotFormatter: {}
  };

  const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'video'
  ];

  return (
    <ReactQuill
      ref={quillRef}
      className="mb-3"
      style={props.style}
      formats={formats}
      theme={props.theme}
      onChange={handleChange}
      value={editorHtml}
      modules={modules}
      bounds={'.quill'}
      placeholder="Insira uma descrição"
    />
  );
});

Editor.displayName = 'Editor';

export default Editor;
